/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricerules_Mock_Bot_Select_ProductsInputs */

const tr_landing_pricerules_mock_bot_select_products = /** @type {(inputs: Landing_Pricerules_Mock_Bot_Select_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ürünleri seç`)
};

const en_landing_pricerules_mock_bot_select_products = /** @type {(inputs: Landing_Pricerules_Mock_Bot_Select_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select products`)
};

const de_landing_pricerules_mock_bot_select_products = /** @type {(inputs: Landing_Pricerules_Mock_Bot_Select_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produkte wählen`)
};

const ru_landing_pricerules_mock_bot_select_products = /** @type {(inputs: Landing_Pricerules_Mock_Bot_Select_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выбрать товары`)
};

/**
* | output |
* | --- |
* | "Select products" |
*
* @param {Landing_Pricerules_Mock_Bot_Select_ProductsInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_pricerules_mock_bot_select_products = /** @type {((inputs?: Landing_Pricerules_Mock_Bot_Select_ProductsInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricerules_Mock_Bot_Select_ProductsInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricerules_mock_bot_select_products(inputs)
	if (locale === "de") return de_landing_pricerules_mock_bot_select_products(inputs)
	if (locale === "ru") return ru_landing_pricerules_mock_bot_select_products(inputs)
	return tr_landing_pricerules_mock_bot_select_products(inputs)
});